import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

// La misma tarjeta que Gestión → Grupos.
export const Section = styled.div`
  padding: ${({ theme }) => theme.spaces.xl}rem;
  border-radius: 1rem;
  background: ${({ theme }) => theme.colors.backgroundLila};
  margin-bottom: ${({ theme }) => theme.spaces.xl}rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spaces.l}rem;
`;

export const StatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.m}rem;
`;

export const StateRow = styled.label`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.m}rem;
  cursor: pointer;
`;
